
export function toggleSidebar_action({ commit }, request = -1) {
    commit('setSidebarToggle_mutation', request);
}

